import React, { FC } from 'react';

import { ManagerPermissionsFiles } from '../ManagerPermissionsFiles';
import { useManagerParams } from '../hooks/useManagerParams';

export const Permissions: FC = () => {
    const { manager } = useManagerParams();
    return <ManagerPermissionsFiles manager={manager} />;
};
